export default {
  key: "role",
  fields: [
    { key: "id" },
    { key: "name_chi" },
    { key: "role" },
    { type: "action-btn" }
  ],
  action: ["delete"],
}